export default __webpack_public_path__ + "e56d63026bedd91bb2af834bc19277b4.png";